import styled from 'styled-components';

export const StyledPipaBalance = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #733200;
  font-family: var(--font-family), Arial;

  .balanceImg {
    height: 14px;
    aspect-ratio: 1/1;
    margin-right: 2px;
    background-color: transparent;
  }
`;
